<template>
	<div>
		<div class="row">
			<div class="col-5 mb-4">
				<h1 v-if="isNew">{{ $t("add-building") }}</h1>
				<h1 v-else-if="loaded">
					{{ building.name }}
				</h1>
				<div class="skeleton midnight h16 w-half" v-else></div>
			</div>
			<div class="col-7 mb-4">
				<button class="float-right btn btn-primary" @click="saveBuilding"
				:disabled="(building.id ===null && !confidencePassed) || !building.name  ">
					{{ $t("save") }}
				</button>
			</div>
		</div>

		<div class="row" v-if="success">
			<div class="col-12">
				<b-alert variant="success" show>Building saved successfully</b-alert>
			</div>
		</div>

		<div class="row" v-if="error">
			<div class="col-12">
				<b-alert variant="danger" show>{{ error }}</b-alert>
			</div>
		</div>

		<div class="row">
			<div class="col-12 mb-2">
				<label>{{ $t("name") }}</label>
				<input
					type="text"
					class="form-control"
					value=""
					:placeholder="$t('enter-building-name')"
					v-model="building.name"
					v-if="loaded"
				/>
				<div class="skeleton midnight h16 w-half" v-else></div>
			</div>

		</div>
		<div class="row" v-if="loaded">
            <div class="col-12 mb-2">
				<LatLong
				:confidenceMargin="10"
				@countries-loaded="parseCountries"
				@change="handleData"
				:location="building"></LatLong>
			</div>
        </div>
	</div>
</template>

<script>
import LatLong from '/src/components/LatLong.vue'

export default {
	components:{
    LatLong
},
	data: function () {
		return {
			success: false,
			building: {
				id: null,
				name: '' ,
				address1: null ,
				address2: null ,
				address3: null ,
				address4: null ,
				address5: null ,
				postcode: null ,
				long: null ,
				lat: null
			},
			error: null,
			loaded: false,
			confidencePassed: false	,
			countries:{}
		};
	},
	mounted() {
		if (this.isNew) {
			// add mode
			this.loaded = true;
		} else {
			// view mode
			this.getBuilding();
		}
	},
	methods: {
		startEditing: function () {
			this.editing = true;
			this.buildingName = this.building.name || "";
			this.buildingLat = this.building.lat || "";
			this.buildingLong = this.building.long || "";
		},
		getBuilding: function () {
			this.$cfetch(
				`${this.$settings.APIBaseURL}/timetable/ttbuilding/get?id=${this.$route.params["buildingid"]}`
			)
				.then((json) => {
					if (json.status === "SUCCESS") {
						this.building = json.result;
						this.loaded = true;
					}
				})
				.catch((err) => console.error(err));
		},
		saveBuilding: function () {
			this.$cfetch(`${this.$settings.APIBaseURL}/timetable/ttbuilding/save`, {
				method: "post",
				data: this.building,
			})
				.then((res) => {
					//console.log("res", res);
					if (res.status === "SUCCESS") {
						this.success = true;
						this.error = null;
						this.editing = false;
						this.building = res.result;
						this.success = true;
					} else {
						if (res.error_message) {
							this.error = res.error_message;
						} else {
							this.error = this.$t("problem-saving-building");
						}
					}
				})
				.catch((error) => {
					this.$log.error.call(this, error);
				});
		},
		handleData(data){
			const { coordinates, address } = data;
			Object.assign(this.building, {
				lat: coordinates.lat,
				long: coordinates.lng,
				address1: address.address1,
				address2: address.address2,
				address3: address.address3,
				address4: address.address4,
				address5: address.address5,
				postcode: address.postcode,
				country: address.country
			});
			this.confidencePassed = data.confidencePassed
		},
		parseCountries(data){
			this.countries =data;
		},
		countryName(code){
			for (let id in this.countries){
				if(id === code){
					return this.countries[id];
				};
			}
		}
	},
	computed: {
		isNew: function () {
			return !this.$route.params["buildingid"];
		}
	},
};
</script>
